import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './style/main.css';
import './utils/vue_cookies'; // cookies操作工具

import './iconfont/iconfont';
import './iconfont/iconfont.css';

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import WXConfig from './utils/wxConfig';
Vue.prototype.WXConfig = WXConfig;

import './utils/map' // 挂载原型方法
import './utils/lib' // 挂载原型方法

import './filter/index' // 过滤器文件 

import 'vant/lib/index.css';

import {
  Area
} from 'vant';

import {
  Popup
} from 'vant';

Vue.use(Area);
Vue.use(Popup);

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

Vue.config.productionTip = false;

// router.addRoute({
//   path: '/cs_qwe/collection',
//   name: '20241206MN',
//   component: function () {
//     return import('@/views/20241206MN/index.vue')
//   },
// });


import {
  message
} from 'ant-design-vue';
Vue.prototype.openPage = function (item) {
  if (item.is_outside_url == 2 && item.meeting_view_id) {
    return this.$router.push('/?view_id=' + item.meeting_view_id)
  }
  if (item.is_outside_url == 1 && item.url) {
    return window.location.href = item.url
  }
  message.success('敬请期待！');
}





Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: false,
  // 是否展示缩略图
  navbar: false
})

Vue.use(Viewer)

// pdf 打开方式
// https://www.cndmcloud.com/home/pdf/web/viewer.html?file=https://www.cndmcloud.com/storage/setmeet/2024-10/前列腺癌药物去势治疗随访管理中国专家.pdf#page=1


// 页面打开时获取localStorage版本号，不一致时清空localStorage
import packageJson from '../package.json'
const version = packageJson.version
const localVersion = localStorage.getItem('projectVersion')
if (!localVersion || version !== localVersion) {
  localStorage.clear()
  localStorage.setItem('projectVersion', version)
  window.location.reload(true);
}


if (process.env.NODE_ENV !== 'development') {
  console.log = function () {}
  console.error = function () {}
  console.dir = function () {}
}

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount('#app');